<template>
  <b-modal
    id="file-upload-modal"
    hide-footer
    :title="disabled ? 'Xem danh sách tệp' : 'Quản lý tệp'"
    size="lg"
  >
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Tải lên tệp"
            description="Chọn nhiều tệp để tải lên (PDF, JPG, PNG, DOCX, XLSX)"
          >
            <b-form-file
              v-model="file"
              ref="fileInput"
              :disabled="disabled"
              accept=".pdf, .jpg, .jpeg, .png, .docx, .xlsx"
              placeholder="Chọn tệp..."
              drop-placeholder="Thả tệp vào đây..."
              multiple
              @change="handleFileUpload"
            ></b-form-file>
            <!-- Hiển thị danh sách file vừa chọn -->
            <b-list-group class="mt-2">
              <b-list-group-item
                v-for="(file, index) in selectedFiles"
                :key="'selected-' + index"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center">
                  <div class="svg-icon">
                    <inline-svg :src="getIconPath(file.type)" />
                  </div>
                  <p class="px-2 m-0 d-flex align-items-center">
                    {{ file.title }}
                  </p>
                </div>
                <div>
                  <b-button
                    v-if="['pdf', 'png', 'jpg', 'jpeg'].includes(file.type)"
                    variant="success"
                    size="sm"
                    class="mr-2"
                    @click="previewSelectedFile(file.previewUrl)"
                  >
                    Xem
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    @click="removeSelectedFile(index)"
                  >
                    Xóa
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-form-group>
          <!-- Danh sách các tệp đã tải lên từ server -->
          <b-form-group
            v-if="existingFiles.length > 0"
            label="Danh sách tệp đã tải lên"
            class="mt-3"
          >
            <b-list-group>
              <b-list-group-item
                v-for="(file, index) in existingFiles"
                :key="'existing-' + index"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center">
                  <span class="svg-icon" :class="{ 'icon-disabled': disabled }">
                    <inline-svg :src="getIconPath(file.type)" />
                  </span>
                  <p
                    class="px-2 m-0 d-flex align-items-center"
                    :class="{ 'text-muted': disabled }"
                  >
                    {{ file.title }}{{ file.type }}
                  </p>
                </div>
                <div>
                  <!-- Nút Xem -->
                  <b-button
                    v-if="
                      file.type === '.pdf' ||
                      file.type === '.png' ||
                      file.type === '.jpg'
                    "
                    variant="success"
                    size="sm"
                    class="mr-2"
                    @click="viewFile(file.fileUrl)"
                  >
                    Xem
                  </b-button>
                  <!-- Nút Tải về -->
                  <b-button
                    size="sm"
                    class="mr-2 btn-success"
                    @click="downloadFile(file.fileUrl, file.title)"
                  >
                    Tải về
                  </b-button>
                  <!-- Nút Xóa -->
                  <b-button
                    v-if="!disabled"
                    variant="danger"
                    size="sm"
                    @click="removeExistingFile(file.id)"
                  >
                    Xóa
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button
          class="btn btn-plain ml-2"
          href="#"
          :disabled="loading"
          @click.stop="handleCancel"
          tabindex="0"
        >
          Hủy
        </b-button>
        <b-button
          v-if="!disabled"
          class="btn btn-success ml-3"
          @click.stop="handleSubmit"
          type="submit"
          :disabled="isDisabled"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Lưu
        </b-button>
        <b-button
          v-if="disabled"
          class="btn btn-success ml-3"
          @click.stop="handelEdit"
          type="submit"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/edit-2.svg" />
          </span>
          Chỉnh sửa
        </b-button>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: 'FileUploadModal',
  props: {
    targetItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      file: [],
      selectedFiles: [],
      existingFiles: [],
      disabled: true,
      isDisabled: false,
    };
  },
  methods: {
    previewSelectedFile(url) {
      window.open(url, '_blank');
    },
    removeSelectedFile(index) {
      if (
        !this.selectedFiles ||
        !Array.isArray(this.selectedFiles) ||
        index < 0 ||
        index >= this.selectedFiles.length
      ) {
        console.error('Invalid index or selectedFiles is empty:', {
          index,
          selectedFiles: this.selectedFiles,
        });
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể xóa file do danh sách trống hoặc chỉ số không hợp lệ.',
        });
        return;
      }
      const removedFile = this.selectedFiles[index];
      if (!removedFile || !removedFile.file) {
        console.error('Invalid file object at index:', index, removedFile);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể xóa file do dữ liệu không hợp lệ.',
        });
        return;
      }
      this.selectedFiles.splice(index, 1);
      this.file = this.file.filter((f) => f !== removedFile.file);
    },
    getIconPath(filename) {
      const ext = filename.toLowerCase();

      switch (ext) {
        case '.doc':
        case '.docx':
          return '/media/svg/icons/Neolex/File/file-doc.svg';
        case '.pdf':
          return '/media/svg/icons/Neolex/File/file-pdf.svg';
        case '.jpg':
        case '.jpeg':
        case '.png':
          return '/media/svg/icons/Neolex/File/file-png.svg';
        case '.xlsx':
        case '.sheet':
          return '/media/svg/icons/Neolex/File/file-exel.svg';
        default:
          return '/media/svg/icons/Neolex/File/file-default.svg';
      }
    },
    handleCancel() {
      this.disabled = true;
      this.file = [];
      this.selectedFiles = [];

      this.$bvModal.hide('file-upload-modal');
    },
    handelEdit() {
      this.disabled = false;
    },
    async handleSubmit() {
      this.isDisabled = true;
      try {
        if (this.file && this.file.length > 0) {
          const formData = new FormData();
          formData.append('customerReceivesId', this.targetItem.id);
          Array.from(this.file).forEach((file) => {
            formData.append('Files', file);
          });
          await this.$api.post('/CustomerReceivesFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }

        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Tải lên tệp thành công.',
        });
        await this.getCustomerFile(this.targetItem.id);
      } catch (error) {
        console.error('Submit Error:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error.message || 'Đã xảy ra lỗi khi tải lên tệp',
        });
      } finally {
        this.isDisabled = false;
        this.file = [];
        this.selectedFiles = [];
        this.$emit('load-data');
        this.$bvModal.hide('file-upload-modal');
      }
    },
    handleFileUpload(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files || !files.length) {
        console.warn('No files selected:', event);
        return;
      }

      this.file = Array.from(files); // Lưu file gốc vào this.file
      this.selectedFiles = []; // Reset selectedFiles để tránh trùng lặp
      Array.from(files).forEach((file) => {
        const allowedTypes = [
          'application/pdf',
          'image/jpeg',
          'image/png',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];
        if (!allowedTypes.includes(file.type)) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: 'Chỉ hỗ trợ tệp PDF, JPG, PNG, DOCX, XLSX.',
          });
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: 'Kích thước tệp không được vượt quá 5MB.',
          });
          return;
        }
        const previewUrl = [
          'image/jpeg',
          'image/png',
          'application/pdf',
        ].includes(file.type)
          ? URL.createObjectURL(file)
          : null;

        let fileType;
        switch (file.type) {
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            fileType = '.xlsx';
            break;
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            fileType = '.docx';
            break;
          case 'application/pdf':
            fileType = '.pdf';
            break;
          case 'image/jpeg':
            fileType = '.jpeg';
            break;
          case 'image/png':
            fileType = '.png';
            break;
          default:
            fileType = '.' + file.type.split('/').pop();
        }

        this.selectedFiles.push({
          title: file.name,
          type: fileType,
          previewUrl: previewUrl,
          file: file,
        });
      });
    },
    async getCustomerFile(id) {
      try {
        const response = await this.$api.get(
          `/CustomerReceivesFile?CustomerReceivesId=${id}`,
        );
        this.existingFiles = response.data.items || [];
      } catch (error) {
        console.error('Error in getCustomerFile:', error);
        this.$toastr.e({
          title: 'Lỗi tải file',
          msg: error.message || 'Không thể tải danh sách file',
        });
        this.existingFiles = [];
      }
    },
    async removeExistingFile(id) {
      this.$swal({
        title: '',
        text: `Bạn có chắc muốn xóa tệp này không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: `Xóa`,
            value: true,
            visible: true,
            className: `btn btn-inactive`,
            closeModal: true,
          },
        },
      }).then(
        async function (result) {
          if (result) {
            try {
              await this.$api.delete(`CustomerReceivesFile/${id}`);
              this.$toastr.s({
                title: 'Thành công!',
                msg: 'Xóa tệp thành công.',
              });
              await this.getCustomerFile(this.targetItem.id);
            } catch (error) {
              console.error('Error in removeExistingFile:', error);
              this.$toastr.e({
                title: 'Lỗi',
                msg: error.message || 'Không thể xóa tệp',
              });
            }
          }
        }.bind(this),
      );
    },
    async downloadFile(file, openInNewTab = true) {
      if (!file.fileUrl) {
        console.error('URL không hợp lệ');
        return;
      }
      try {
        if (openInNewTab) {
          window.open(file.fileUrl, '_blank');
        } else {
          const link = document.createElement('a');
          link.href = file.fileUrl;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (error) {
        console.error('Lỗi khi xử lý file:', error);
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể tải file.',
        });
      }
    },
    viewFile(url) {
      try {
        window.open(url, '_blank');
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Không thể mở file.',
        });
      }
    },
  },
  watch: {
    targetItem: {
      deep: true,
      handler(val) {
        if (val.id) {
          this.getCustomerFile(val.id);
        }
      },
    },
  },
};
</script>
<style>
.svg-icon.icon-disabled svg {
  opacity: 0.5; /* Làm mờ icon khi disabled */
  transition: opacity 0.3s ease; /* Hiệu ứng chuyển đổi mượt mà */
}

.svg-icon svg {
  opacity: 1; /* Trạng thái bình thường */
  transition: opacity 0.3s ease;
}
</style>
